import { apiClient } from "../client-api";
import { authHeader } from "../../_helpers";
import merge from "lodash/merge";

export default {
  all(conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    return apiClient.get("sapp/v2/applications", conf);
  }
};
